import {Component, inject} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {MatIcon} from '@angular/material/icon';

@Component({
  selector: 'app-customer-newsletter-info-modal',
  standalone: true,
  imports: [
    MatIcon
  ],
  templateUrl: './customer-newsletter-info-modal.component.html',
  styleUrl: './customer-newsletter-info-modal.component.scss'
})
export class CustomerNewsletterInfoModalComponent {

  readonly dialogRef = inject(MatDialogRef<CustomerNewsletterInfoModalComponent>);

  closeModal() {
    this.dialogRef.close();
  }
}
